// @flow

import React from 'react';
import styled from 'styled-components';

import PillButton from 'components/shared/pill-button';
import Button from 'components/shared/button';

import {
  WHITE,
  GREY_10,
  GREY_50,
  CLARK_PRIMARY,
  CLARK_SECONDARY,
  CLARK_ACCENT_PRIMARY,
} from 'styles/colors';
import { TYPE_SCALE_F6, TYPE_SCALE_F5, TYPE_SCALE_F1 } from 'styles/type-scale';
import { FONT_WEIGHT_100, FONT_WEIGHT_700 } from 'styles/font-weight';
import { SPACING_SMALL, SPACING_MEDIUM, SPACING_LARGE } from 'styles/spacing';
import { BORDER_RADIUS_F3 } from 'styles/border-radius';
import { BORDER_WIDTH_1 } from 'styles/borders';
import { LINE_HEIGHT_COPY } from 'styles/line-height';

const InfoCard = ({
  headline,
  subHeadline,
  buttonCopy,
  borderColor,
  hasShadow = false,
  charge,
  details,
  handleClick,
}: any) => {
  const { amount, description, status } = charge;
  return (
    <Card borderColor={borderColor} hasShadow={hasShadow}>
      <Header>
        {headline && <Headline>{headline}</Headline>}
        {subHeadline && <SubHeadline>{subHeadline}</SubHeadline>}
        {charge && (
          <ChargeContainer>
            {amount && <ChargeAmount>{amount}</ChargeAmount>}
            {description && <ChargeDescription>{description}</ChargeDescription>}
          </ChargeContainer>
        )}
        {status && <PillButtonWrapper status={status.type}>{status.text}</PillButtonWrapper>}
      </Header>
      {details && (
        <Details>
          <DetailsTable>
            <tbody>
              {details.map(detail => (
                <DetailsRow key={detail.title}>
                  <DetailsDataTitle>{detail.title}</DetailsDataTitle>
                  <DetailsData>{detail.data}</DetailsData>
                </DetailsRow>
              ))}
            </tbody>
          </DetailsTable>
          {buttonCopy && (
            <ButtonWrapper>
              <Button onClick={handleClick}>Pay Now</Button>
            </ButtonWrapper>
          )}
        </Details>
      )}
    </Card>
  );
};

export default InfoCard;

const renderBorder = {
  primary: CLARK_PRIMARY,
  secondary: CLARK_SECONDARY,
  tertiary: CLARK_ACCENT_PRIMARY,
};

const Card = styled.div`
  ${BORDER_RADIUS_F3};
  background-color: ${WHITE};
  border: ${props =>
    props.borderColor ? `solid ${BORDER_WIDTH_1} ${renderBorder[props.borderColor]}` : 0};
  box-shadow: ${props => (props.hasShadow ? `0 0 20px 0 ${GREY_10}` : 0)};
  margin: 0 auto;
  width: 280px;
`;

const Header = styled.div`
  padding: ${SPACING_LARGE};
  text-align: center;
`;

const Headline = styled.h3`
  ${TYPE_SCALE_F5};
  color: ${CLARK_SECONDARY};
  margin: 0;
`;

const SubHeadline = styled.p`
  ${TYPE_SCALE_F6};
  ${FONT_WEIGHT_100};
  color: ${GREY_50};
  margin: ${SPACING_SMALL} 0 0;
`;

const ChargeContainer = styled.div`
  margin: calc(${SPACING_LARGE} + ${SPACING_MEDIUM}) ${SPACING_MEDIUM} 0;
`;

const ChargeAmount = styled.span`
  ${TYPE_SCALE_F1};
  ${FONT_WEIGHT_100};
  color: ${CLARK_SECONDARY};
  margin: ${SPACING_SMALL} 0 0;
`;

const ChargeDescription = styled.p`
  ${TYPE_SCALE_F6};
  ${FONT_WEIGHT_100};
  ${LINE_HEIGHT_COPY};
  color: ${CLARK_SECONDARY};
  margin: ${SPACING_SMALL} 0 0;
`;

const PillButtonWrapper = styled<any>(PillButton)`
  margin-top: ${SPACING_MEDIUM};
`;

const Details = styled.div`
  border-top: ${BORDER_WIDTH_1} solid ${GREY_50};
  margin-top: calc(${SPACING_LARGE} + ${SPACING_MEDIUM});
`;

const DetailsTable = styled.table`
  padding: ${SPACING_LARGE};
  width: 100%;
`;

const DetailsRow = styled.tr`
  display: flex;
  justify-content: space-between;
`;

const DetailsData = styled.td`
  ${TYPE_SCALE_F6};
  ${FONT_WEIGHT_100};
  ${LINE_HEIGHT_COPY};
  color: ${CLARK_SECONDARY};
`;

const DetailsDataTitle = DetailsData.extend`
  ${FONT_WEIGHT_700};
`;

const ButtonWrapper = styled.div`
  padding: 0 ${SPACING_MEDIUM} ${SPACING_MEDIUM};
`;



// WEBPACK FOOTER //
// ./src/components/shared/info-card/index.js